// extracted by mini-css-extract-plugin
export default {"previousBtn":"styles_previousBtn__OTfgk","nextBtn":"styles_nextBtn__q0-VX","pageBtn":"styles_pageBtn__IhFiv","paginationComponent":"styles_paginationComponent__ODTgu"};